import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { useTranslation } from 'react-i18next';
import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';

interface MultiBatchesFormProps {
  movement: any;
  batches: any[];
  setBatch: any;
  onSubmit: any;
}

function SelectMultiBatchesForm({ batches, setBatch, onSubmit, movement }: MultiBatchesFormProps) {
  const { t } = useTranslation();

  return (
    <EnhancedForm
      onSubmit={(values) => {
        const updatedMovement = {
          ...movement,
          product_batch: batches.find((batch) => batch.code === values.product_batch).id
        };
        onSubmit(
          updatedMovement,
          batches.find((batch) => batch.code === values.product_batch).expiration_date
        );
      }}
      formId="updateBatches"
      hideControls>
      <IdentityField
        name="product_batch"
        label={t('entities.movement.product_batch')}
        component={AutocompleteAdapter}
        options={batches}
        optionValue={'code'}
        initValue={batches.find((batch) => batch.id === movement.product_batch)}
        setValue={setBatch}
        type="text"
        request
      />
    </EnhancedForm>
  );
}

export default SelectMultiBatchesForm;
